export const calculateReportInfluencer = (orders) => {
    // Filter completed or processing orders
    const completedOrders = orders?.filter(order => 
      order?.status === 'COMPLETED' || order?.status === 'PAYMENT_PROCESSING'
    ) || [];
    
    // Count the number of orders
    const resultOrder = completedOrders?.length || 0;
    
    // Use reduce to calculate all sums in a single pass
    const totals = completedOrders.reduce((acc, order) => {
      // Sum up the influencer's commission (totalAffiliate)
      
      // Sum up the shop's revenue (sumPrice)
      if (order?.typeForAffiliate === 'ORDER_NOMAL') {
        acc.sumPriceShop += order?.sumPrice || 0;
      } else if (order?.typeForAffiliate === 'ORDER_AFFILIATE') {
        //TODO: For affiliate orders, subtract the influencer commission from sumPrice
        const commission = order?.sumPrice * (parseInt(order?.infulancer_percent) / 100);
        const newCommission = order?.totalAffiliate !== commission ? commission : order?.totalAffiliate;
        acc.sumPriceInfluencer += newCommission || 0;
        acc.sumPriceShop += (order?.sumPrice || 0) - (newCommission || 0);
      }
      
      // Calculate total order amount from sumPrice
      acc.totalOrderAmount += order?.sumPrice || 0;
      
      return acc;
    }, {
      sumPriceInfluencer: 0,
      sumPriceShop: 0,
      totalOrderAmount: 0
    });

    // Calculate the total stock
    const totalStock = completedOrders.reduce((acc, order) => {
      acc += order?.amount || 0;
      return acc;
    }, 0);
    
    
    return {
      resultOrder,
      ...totals,
      totalStock
    };
};